import useCream from '../../../../contexts/cream';
import useInitFight from '../../../../contexts/initFight';
import useWs from '../../../../contexts/websockets';
import WSExitWrapper from './exitWrapper';
import BattleConnectingStage from './connecting';
import BattleWaitingStage from './waiting';
import BattleActionStage from './action';
import React from 'react';
import { IFightNft } from '../../../../interfaces/FightNft';
import { BattleStage, BattleStages } from '../../../../interfaces/BattleStage';
import { useAssets } from '../../../../contexts/assets';

interface Props {
  stage: BattleStage;
  switchToWaiting: (nft: IFightNft, bet: number) => void;
  switchToAction: (nft: IFightNft, bet: number) => void;
}

const BattleRouter = ({ stage, switchToWaiting, switchToAction }: Props) => {
  const { getBalance } = useCream();
  const { goResults } = useInitFight();
  const { wsDisconnect } = useWs();
  const { sound } = useAssets();

  switch (stage.marker) {
    case BattleStages.CONNECTING: {
      const { nft, bet, nextStage } = stage;
      const proceed = () => {
        if (nextStage === BattleStages.WAITING) {
          switchToWaiting(nft, bet);
        } else {
          switchToAction(nft, bet);
        }
      };
      return (
        <WSExitWrapper>
          <BattleConnectingStage next={proceed} />
        </WSExitWrapper>
      );
    }

    case BattleStages.WAITING: {
      const { nft, bet } = stage;
      return (
        <WSExitWrapper isQueue>
          <BattleWaitingStage
            nft={nft}
            bet={bet}
            next={() => {
              getBalance();
              sound.queueMatch();
              switchToAction(nft, bet);
            }}
          />
        </WSExitWrapper>
      );
    }

    case BattleStages.ACTION: {
      const { nft, bet } = stage;
      const proceed = (fightId: string) => {
        wsDisconnect();
        goResults(fightId, true);
      };
      return <BattleActionStage nft={nft} bet={bet} next={proceed} />;
    }

    default:
      return (
        <>
          <h1 className='mb-20'>Something went wrong!</h1>
          <h2>Please refresh a page</h2>
        </>
      );
  }
};

export default BattleRouter;
